
<template>
<div class="row clearfix">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="">
        <div class="body">
          <ul class="tabMenu nav nav-tabs">
            <li class="nav-item" style="margin-bottom: -23px">
              <button
                class="tabButtons nav-link"
                type="button"
                @click="toActionSetting"
              >
                설정
              </button>
              &nbsp;&nbsp;
            </li>
            <li class="nav-item" style="margin-bottom: -23px">
              <button
                class="tabButtons nav-link active"
                type="button"
                @click="againInputPage"
              >
                인풋설정
              </button>
              &nbsp;&nbsp;
            </li>
            <li class="nav-item" style="margin-bottom: -23px">
              <button
                class="tabButtons nav-link"
                type="button"
                @click="toActionApi"
              >
                API 설정
              </button>
              &nbsp;&nbsp;
            </li>
          </ul>

          <div class="tabContent tab-content">
            <div role="tabpanel" class="tab-pane active">
              <!-- Spinners -->
              <div class="card">
                <div class="row clearfix">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="card">
                      <!-- <div class="header">
                                            <h2><strong>Form Editor</strong></h2>
                                        </div> -->

                      <dev-action-input ref="toMain" />
                    </div>
                  </div>
                  <!-- #END# Spinners -->
                  <!-- Tags Input -->
                  <!-- <div class="col-lg-6 col-md-12 col-sm-12">
                                <div class="card">
                                    <div class="header">
                                        <h2> preview</h2>
                                    
                                    </div>
                                    <div class="body">
                                        <div class="form-group demo-tagsinput-area">
                                            <div class="form-line">
                                                <input type="text" class="form-control" data-role="tagsinput" value="미리보기이">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DevActionInput from "@/views/dev/action/DevActionInput";
import eventbus from "@/store/modules/devEventBus";

export default {
  name: "DevActInput",
  props: ["menuData"],
  components: {
    DevActionInput : DevActionInput,
  },
  data() {
    return {
      heading: this.menuData,
      toMain: false,
      fieldNum: 0,
    };
  },
  methods: {
    tabChanged() {
      this.$router.push("settings");
      this.$router.replace("settings");
    },
    toActionApi() {
      this.$router.push({
        name: "DevActApi",
        params: { appId: this.$route.params.appId },
      });
    },
    toActionSetting() {
      this.$router.push({
        name: "DevActSetting",
        params: { appId: this.$route.params.appId },
      });
    },
    againInputPage() {
      console.log("클릭", this.$store.state.devStore.apiSchema);

      if (this.fieldNum == 1) {
        this.$refs.toMain.cancelAlert();
      } else if (this.fieldNum == 2) {
        this.$store.state.devStore.apiSchema = null;
        this.$router.push({
          name: "DevActInput",
          params: { appId: this.$route.params.appId },
        });
      }

      // if(this.$store.state.devStore.apiSchema != null && this.$store.state.devStore.apiSchema.checkType.includes("field")){
      // this.$store.state.devStore.apiSchema = null

      // } else {

      // }
    },
  },
  created() {
    console.log("DevActInput.created");

    this.fieldNum = 0;

    eventbus.$on("fieldNum", (res) => {
      this.fieldNum = res;
    });

  },
  mounted() {
    console.log("DevActInput.mounted");
  },
  beforeDestroy() {
    console.log("DevActInput.beforeDestroy");

    eventbus.$off("fieldNum");

  }
}
</script>
